import { Injectable } from "@angular/core";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";

@Injectable({
  providedIn: "root"
})
export class PlusdCommonService {
  public APPLICATION_API_HOST: string = "";

  constructor(public xsAppConfigService: XsAppConfigService) {
    this.APPLICATION_API_HOST = "/sso2/OefaAdmSeg";
   
  }
}
